<button (click)="click()" [ngClass]="{'active-button': active, 'no-shadow': noShadow, 'no-active-color': noActiveColor}"
        mat-mini-fab
    (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()" [disabled]="disable">
    <mat-icon *ngIf="icon">{{icon}}</mat-icon>
    <mat-icon [ngClass]="{'custom-like-layout': svgIcon == 'mwo-like' || svgIcon == 'mwo-like_active'}" *ngIf="!icon"
        [svgIcon]="svgIcon"></mat-icon>
</button>
